import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Option extends Component {
  handleKeyPress(event) {
    if (event.key === "Enter") {
      const onSubmit = this.props.onSubmit;
      onSubmit();
    }
  }
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return (
      <option value={this.props.value} className={finalRootClass} onKeyPress={this.handleKeyPress.bind(this)}>
        {typeof this.props.label !== "undefined" && this.props.label}
        {typeof this.props.label === "undefined" && this.props.children}
      </option>
    );
  }
}

Option.propTypes = {
  rootClassname: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Option/index.js